
export const userRolesNav = [
    {url: '/roles', label: 'User Roles', key: 'roles.index', permissions: []},
]